import styled from 'styled-components';
import Colours from '../../constants/colours';

export const Extended = styled.div`
  border-top: 1px solid ${Colours.grey[300]};
  margin-top: 1rem;
  padding-top: 1rem;
`;
